import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoIconSmall]',
  host: { class: 'xpo-Icon--small' },
})
export class XpoIconSmall {}
